import React from "react";
import {Modal, Spinner} from "react-bootstrap";
import Back from "assets/images/svg/back_blue.svg";
import Info from "assets/images/svg/info_dark.svg";
import Countdown from "react-countdown";
import {Form, InputField} from "components/form";
import {client} from "helpers/client";
import {useQueryClient} from "react-query";
import {useStatus} from "hooks/use-status";
import SorryPhoneDialog from "pages/security-login/components/sorry-phone.dialog";
import {isBlocked, isExpired} from "pages/security-login/security-login.service";
import {useTranslation} from "react-i18next";

interface Props {
  show: boolean;
  onHide: () => void;
  mobileId?: number;
  block?: string;
  expire?: string;
  onResend: () => any;
}

const VerifyPhoneDialog = ({ show, onHide, expire ,mobileId,onResend,block}: Props) => {
    const {t} = useTranslation('security');
    const {isLoading,load,done,stop} = useStatus();
    const queryClient = useQueryClient();

  async function handleVerifyPhone(data:any) {
      load();
      const verificationDto = {
          mobileId,
          "code": data.verificationCode
      }
      const {response} = await client('/auth/verifyMobile',{data:verificationDto})
      if(response) {
          done()
          queryClient.invalidateQueries('mobiles-data').then(() => onHide());
      }else {
          stop();
      }
  }
  if(isBlocked(block) && !isExpired(expire)) return <SorryPhoneDialog show={show} onHide={onHide} onResend={onResend} expire={block} />
  return (
    <div>
      <Modal
        centered
        size="lg"
        show={show}
        className="all-modal verifyPhoneNumber"
      >
        <Modal.Body>
          <div className="header">
            <img src={Back} alt="back" onClick={onHide} />
            <h1>{t('verify-phone-number')}</h1>
          </div>
          <Form onSubmit={handleVerifyPhone} className="row">
            <div className="col-md-12">
              <InputField
                id="verificationCode"
                type="text"
                label={t('verify-code')}
                rules={{
                  required: "errors:required",
                  minLength: {
                    value: 5,
                    message: "errors:invalidFormat",
                  },
                  maxLength: {
                    value: 5,
                    message: "errors:invalidFormat",
                  },
                }}
              />
              <p className="info">
                <img src={Info} alt="" />
                  {t('we-sent-code-to-your-number')}
              </p>
            </div>
            <div className="col-6">
              <button disabled={isLoading} className="btn-blue">
                {isLoading && <Spinner animation="border" size='sm' />} {t('verify')}
              </button>
            </div>
            <div className="col-6">
              <Countdown
                key={expire?.toString() ?? ""}
                date={expire ?? Date.now()}
                renderer={(cd) => {
                  return cd.completed ? (
                    <button onClick={onResend} type="button" className="btn-timer">
                        {t('send-again')}
                    </button>
                  ) : (
                    <button type="button" className="btn-timer">
                      {cd.formatted.hours}:{cd.formatted.minutes}:
                      {cd.formatted.seconds}
                    </button>
                  );
                }}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VerifyPhoneDialog;
